import useFilters from "@/core/hooks/useFilters";
import useTranslation from "@/core/hooks/useTranslation";
import TablePage, {
  ICustomBreadcrumbsLink,
} from "@/presentation/components/TablePage";
import sliceNames from "@/redux/names";
import commissionEffects from "@/redux/slices/commission/effects";
import { useSelector } from "@/redux/store";
import commissionColumns from "./data/columns";
import {
  commissionTableTopOptions,
  commissionToolbarOptions,
} from "./data/constants";
import commissionFields from "./data/fields";

interface ICommissionProps {
  additionalFilters?: Record<string, string | undefined>;
  breadcrumbs?: null | ICustomBreadcrumbsLink[];
  noPage?: boolean;
}
export default function CommissionsPage({
  additionalFilters,
  breadcrumbs,
  noPage,
}: ICommissionProps) {
  // Store
  const { commission } = useSelector((state) => state);

  // Hooks
  const t = useTranslation();
  const {
    getData,
    handleKeyword,
    handlePaymentType,
    handleStatus,
    handleOrder,
    handleOrder_field,
    handlePage,
    handlePer_page,
    keyword,
    paymentType,
    status,
    order: _order,
    order_field,
  } = useFilters({
    effects: commissionEffects,
    initialState: {
      page: commission.list.current_page,
      per_page: commission.list.per_page,
      keyword: "",
      paymentType: "",
      status: "",
      order: "",
      order_field: "",
      ...(additionalFilters ?? {}),
    },
  });

  return (
    <TablePage
      model={sliceNames.commission}
      // ** Breadcrumbs **
      breadcrumbLinks={breadcrumbs}
      // ** Genre **
      female
      // ** Toolbar **
      tableTopOptions={commissionTableTopOptions}
      toolbarOptionChange={handleStatus}
      currentToolbarOption={status}
      toolbarOptions={commissionToolbarOptions({
        value: keyword,
        onChange: handleKeyword,
      })}
      // ** On Select rows **
      idProperty="uuid"
      // ** Table CRUD **
      noCrud
      fields={commissionFields(t, [])}
      stateData={commission}
      columns={commissionColumns}
      effects={commissionEffects}
      getData={getData}
      // ** Filter options **
      isFiltered={(data) =>
        keyword !== "" || paymentType !== "" || status !== ""
      }
      onReset={() => {
        handleKeyword("");
        handlePaymentType("");
        handleStatus("");
      }}
      // ** Sorting **
      handleFilterOrder={handleOrder}
      handleFilterOrderField={handleOrder_field}
      order={_order}
      orderField={order_field}
      // ** Pagination **
      onChangePage={handlePage}
      onChangeRowsPerPage={handlePer_page}
      noPage={noPage}
    />
  );
}
